import { render } from "./BaseSquareCheckBox.vue?vue&type=template&id=50441187&scoped=true"
import script from "./BaseSquareCheckBox.vue?vue&type=script&lang=js"
export * from "./BaseSquareCheckBox.vue?vue&type=script&lang=js"

import "./BaseSquareCheckBox.vue?vue&type=style&index=0&id=50441187&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50441187"]])

export default __exports__